import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconProp;
};
export function PaginationButton({
  icon,
  children,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <button
      {...props}
      type="button"
      className={clsx(
        className,
        'rounded-md p-1 text-sm outline-solid outline-1 outline-slate7 disabled:cursor-default disabled:bg-slate4 disabled:text-slate11! hocus:text-blue11 hocus:outline-blue8 disabled:hocus:outline-slate7'
      )}
    >
      <Icon icon={icon} />
    </button>
  );
}

PaginationButton.displayName = 'PaginationButton';
